
import { FaMapMarkerAlt, FaClock, FaUserMd } from 'react-icons/fa';
import eczema from './../../../assets/images/eczemabanner.png';
import eczematreatment from './../../../assets/images/eczemaappointment.png';
import eczemagallery1 from './../../../assets/images/eczema.jpg';
import eczemagallery2 from './../../../assets/images/eczemagallery2.png';
import eczemagallery3 from './../../../assets/images/eczemagallery2.png';
import eczemagallery4 from './../../../assets/images/eczemagallery4.png'; 

//disease psoriasis
import bestpsoriasis from './../../../assets/images/best psoriasis treatment banner.png'
import Psoriasis1 from './../../../assets/images/Psoriasis.jpg';
import Psoriasis12 from './../../../assets/images/Psoriasis-Treatment-in-Homeopathy..jpg';
import Psoriasis2 from './../../../assets/images/scalp-psoriasis-treatment.jpg';
import Psoriasis3 from './../../../assets/images/psoriasis on body Treatment.png';
import Psoriasistreatment from './../../../assets/images/Psoriasistreatment.jpg'

// disease Asthma
import AsthmaBanner from './../../../assets/images/asthmabanner.png';
import Asthma1 from './../../../assets/images/asthmatreatment1.png';
import Asthma2 from './../../../assets/images/asthmatreatment2.png';
import Asthma3 from './../../../assets/images/asthmatreatment3.png';
import Asthma4 from './../../../assets/images/asthmatreatment4.png';

//disease diabetes
import diabetesBanner from './../../../assets/images/diabetesbanner.png';
import diabetes1 from './../../../assets/images/asthmatreatment1.png';
import diabetes2 from './../../../assets/images/asthmatreatment2.png';
import diabetes3 from './../../../assets/images/asthmatreatment3.png';
import diabetes4 from './../../../assets/images/asthmatreatment4.png';
import diabetesappointment from './../../../assets/images/diabetesappointment.png'

//disease diabetes
import migranebanner from './../../../assets/images/migranebanner.png';
import migrane1 from './../../../assets/images/asthmatreatment1.png';
import migrane2 from './../../../assets/images/asthmatreatment2.png';
import migrane3  from './../../../assets/images/asthmatreatment3.png';
import migrane4 from './../../../assets/images/asthmatreatment4.png';
import migranappointment from './../../../assets/images/migraneappointment.jpg'


export const diseaseData = [
// eczema
  {
        id: "eczema",
        name: "eczema",
        metadata:[
          {
          title: "Eczema Treatment | H-Cura Homeopathy",
          description: "Get expert homeopathy treatment for eczema at H-Cura Homeopathy. Book your consultation today for safe and effective care.",
          keywords: "Eczema treatment, Homeopathy for eczema, H-Cura Homeopathy, Best homeopathy clinic for skin diseases",
          canonicalUrl: "https://www.h-cura.com/treatments/eczema",
          favicon: "/assets/images/favicon.ico"
          }
        ],
        content: [
            { type: "heading", content: "Best Homeopathic Eczema Treatment" },
        ],
        content1: [
            {
                type: "image",
                src: eczema,
                alt: "eczema-image1",
                className: "treatment-banner",
            },
            {
                type: "text",
                content: "Eczema Treatment",
                className: "treatment-text",
            },
            {
                type: "link",
                to: "/bookconsultation",
                buttonText: "Book Appointment",
                className: "book-appointment-button",
            },
        ],
        content2:[
            
                { type: "heading", content: "Best Homeopathic Eczema Treatment" },
            
        ],

        content3: [
            
            {
                type: "heading",
                content: "Eczema: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
                className: "treatmentprecautions",
            },
            {
                type: "subheading",
                content: "Understanding Eczema",
                className: "treatmentprecautions",
            },
            {
                type: "paragraph",
                content: "Eczema is a chronic skin condition that manifests as red, itchy, and inflamed skin. This condition can affect individuals of any age and may occur on various body parts such as the face, neck, hands, and feet. The severity of eczema can range from mild irritation to severe cases that significantly impact daily life. Eczema on the face often leads to visible distress and emotional challenges, as it can impact one's self-esteem. Dyshidrotic eczema often causes blisters and intense itching on the hands and feet, which can severely affect daily activities.",
                className: "treatmentprecautions",
            },
        ],

        content4:[
           
            {
              type: "list",
              content: "Causes of Eczema",
              className: "treatmentinfection1",
              items: [
                "Genetic Factors: A family history of eczema or allergies increases the risk of developing eczema.",
                "Environmental Factors: Temperature, humidity changes, and pollution can worsen eczema symptoms.",
                "Allergens: Dust, pet dander, and certain foods like dairy and nuts trigger eczema flare-ups.",
                "Stress: Stress can lead to worsening eczema symptoms or outbreaks.",
                "Other Autoimmune Disorders: Harsh soaps and skin irritants aggravate eczema symptoms."
              ],
             
            },
            {
              type: "image-overlay",
              src: eczematreatment, // Replace with your actual image path
              alt: "Eczema Treatment Image",
              title: "Book an Appointment",
              description: "Effective solutions to smooth and heal your skin.",
              link: "/bookconsultation",
              buttonText: "Book Appointment",
              
            }
          ],
        content5:[
           
              {
                type: "list",
                content: "Complications of Eczema",
                items: [
                  "Bacterial and fungal infections: Scratching open the skin can allow bacteria to enter, leading to infections.",
                  "Permanent skin thickening or scarring: Chronic scratching and inflammation can cause the skin to become leathery and thickened.",
                  "Sleep disturbances: The constant itching can affect your ability to sleep, leading to fatigue and irritability."
                ],
               
              },
              {
                type: "list1",
                content: "Symptoms of Eczema",
                content1: "Eczema symptoms vary widely and depend on the type and severity of the condition. Typical symptoms include persistent itching, red or inflamed skin, dry and scaly patches, oozing sores, and skin thickening in chronic cases.",
                items: [
                  "Persistent itching is often the most bothersome symptom of eczema, leading to scratching and skin damage.",
                  "Red, inflamed skin may appear pink, red, or darker in certain individuals, causing irritation.",
                  "Dry, cracked skin becomes extremely dry and can crack, causing discomfort and potential damage."
                ],
                
              }
            
        ],

        content6:[
            {
              type: "paragraph",
              content: "Diagnosis of Eczema",
              content1:
                "At H-Cura Homeopathy, we adopt a comprehensive approach to diagnosing eczema. This involves a detailed medical history review, physical examination, and identification of specific triggers. A detailed medical history review plays a crucial role in identifying genetic and environmental factors that contribute to eczema. It helps to understand the patient’s family history, past health conditions, and potential allergens A physical examination of the skin is essential to assess its characteristics and distinguish between different types of eczema. By carefully examining the skin, a healthcare provider can determine the severity and type of eczema, which is vital for effective treatment Additionally, identifying triggers such as environmental stress, diet, or exposure to specific substances allows for the development of a personalized treatment plan tailored to the patient’s unique needs. This comprehensive approach ensures a more accurate diagnosis and targeted therapy for managing eczema.",
              className: "treatmentDiagnosis"
            },
            
          ],

         content7:[
            
                { src: eczemagallery1, alt: "eczema" },
                { src: eczemagallery2, alt: "eczema" },
                { src: eczemagallery3, alt: "eczema" },
                { src: eczemagallery4, alt: "eczema" }
              
         ],
         content8:[
              {
                title1: "Homeopathic Treatment for Eczema at H-Cura",
                description1:
                  "Our homeopathic treatments focus on addressing the root causes of eczema and promoting long-term healing. By strengthening the immune system and minimizing dependence on conventional medications, our remedies are safe and effective.",
               }],
              content9:[   {
                  icon: <FaMapMarkerAlt className="feature-icon1" />,
                  title: "Strengthen the immune system",
                  description: "We focus on rebalancing the immune system to prevent flare-ups."
                },
                {
                  icon: <FaUserMd className="feature-icon1" />,
                  title: "Promote skin health",
                  description: "Our remedies work on restoring the skin’s natural barrier and preventing dryness, itching, and irritation."
                },
                {
                  icon: <FaClock className="feature-icon1" />,
                  title: "Personalized Follow-Ups",
                  description: "Regular monitoring and adjustments ensure the best results."
                }
              ],
              content10:[
                {
                  title: "Why Choose H-Cura Homeopathy for Eczema Treatment?",
                },
              ],
              content11:[
                {
                  description:
                    "Our treatment addresses the root causes of eczema and emphasizes overall health and wellness.",
                },
                {
                  description:
                    "With years of experience in treating eczema, our practitioners provide expert care for optimal healing.",
                },
                {
                  description:
                    "We focus on patient-centric care, developing personalized treatment plans based on each patient's symptoms and lifestyle.",
                },

              ],
            content12:[
              
                {
                  title: "Effective Management of Eczema",
                },
              
            ],
            content13:[
           
              {
                type: "list",
                content: "Types of Eczema We Treat",
                items: [
                  "Eczema on the face: We provide gentle treatments to restore skin health and address the visible impact of eczema on the face.",
                  "Dyshidrotic eczema: Our remedies target the hands and feet, providing relief from itching and discomfort.",
                  "Scalp eczema: Treatment is focused on reducing flaking, soothing the scalp,and alleviating itching."
                ],
               
              },
              {
                type: "list1",
                content: "Key Features of Our Eczema Treatment",
                content1: " Our approach to eczema care at H-Cura includes natural remedies eczema that are free of harsh chemicals and tailored to individual needs. We ensure that every treatment addresses both the visible symptoms, like eczema rash, and the underlying causes.",
                items: [
                  "Tailored care plans that address each patient's unique eczema symptoms and triggers",
                  "Safe and gentle remedies suitable for both children and adults, ensuring effective treatment.",
                  "Convenient access to both online and offline consultations,making it easy to start your healing journey from anywhere."
                
                ],
                
              }
            
        ],

        content14:[
          {
            title: "Conclusion",
            content:
              "Eczema, though challenging, is a manageable condition with the right care and expertise. At H-Cura Homeopathy Multispecialty Clinic, we offer the best eczema treatment that prioritizes your well-being and long-term skin health.",
          },
          {
            title: "",
            content:
              "Our treatments provide lasting relief for eczema rashes and severe cases. We help you achieve healthier, itch-free skin through natural remedies and lifestyle management. Your health is our priority.",
          },
        ],
        
        
  },
//psoriasis
    {
      id: "psoriasis",
      name: "psoriasis",
      content: [
          { type: "heading", content: "Best Homeopathic   Psoriasis Treatment" },
      ],
      content1: [
          {
              type: "image",
              src: bestpsoriasis,
              alt: "psoriasis-image1",
              className: "treatment-banner",
          },
          {
              type: "text",
              content: " Psoriasis Treatment",
              className: "treatment-text",
          },
          {
              type: "link",
              to: "/bookconsultation",
              buttonText: "Book Appointment",
              className: "book-appointment-button",
          },
      ],
      content2:[
          
              { type: "heading", content: "Best Homeopathic psoriasis Treatment" },
          
      ],

      content3: [
          
          {
              type: "heading",
              content: "Psoriasis: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy Multispecialty Clinic",
              className: "treatmentprecautions",
          },
          {
              type: "subheading",
              content: "Understanding Psoriasis",
              className: "treatmentprecautions",
          },
          {
              type: "paragraph",
              content: "soriasis is a long-lasting, non-contagious autoimmune disorder that predominantly affects the skin. This chronic skin condition manifests as an itchy, scaly rash, often occurring on the knees, elbows, trunk, and scalp. It can vary in severity, ranging from small patches to extensive outbreaks.",
              className: "treatmentprecautions",
          },
      ],

      content4:[
         
          {
            type: "list",
            content: "Causes of Psoriasis",
            className: "treatmentinfection1",
            items: [
              "Infections: Bacterial or viral infections can act as triggers.",
              "Skin Injuries: Minor cuts, scrapes, or burns may lead to the development of psoriatic lesions.",
              "Certain Medications: Drugs such as lithium and beta-blockers are known to exacerbate.",
              "Genetics: Family history plays a significant role in the susceptibility to psoriasis.",
              "Other Autoimmune Disorders: Conditions like rheumatoid arthritis may coexist with psoriasis."
            ],
           
          },
          {
            type: "image-overlay",
            src: Psoriasistreatment, // Replace with your actual image path
            alt: "Eczema Treatment Image",
            title: "Book an Appointment",
            description: "Effective solutions to smooth and heal your skin.",
            link: "/bookconsultation",
            buttonText: "Book Appointment",
            
          }
        ],
      content5:[
         
            {
              type: "list",
              content: "Complications of Psoriasis",
              items: [
                "Psoriatic Arthritis: A chronic condition characterized by joint pain, swelling, and stiffness.",
                "Pustular Psoriasis: Marked by pus-filled bumps that can be painful.",
                "Nail Psoriasis: Results in changes to nail appearance, such as pitting or separation."

              
                
              ],
             
            },
            {
              type: "list1",
              content: "Symptoms of Psoriasis",
              content1: "Symptoms can differ from person to person, but common indicators include:",
              items: [
                "Patches of thick red skin with shiny white scales on areas like the elbows, knees, scalp, palms, and soles of the feet.",
                "Psoriasis rash, which is often itchy and uncomfortable.",
                "Specific types like guttate psoriasis, appear as small, dot-like lesions."
                
              ],
              
            }
          
      ],

      content6:[
          {
            type: "paragraph",
            content: "Diagnosis of Psoriasis",
            content1:
              "Diagnosis is primarily based on the appearance of skin plaques and a thorough evaluation of symptoms. A skin biopsy may occasionally be performed to confirm the condition.",
            className: "treatmentDiagnosis"
          },
          
        ],

       content7:[
          
              { src: Psoriasis1, alt: "psoriasis" },
              { src: Psoriasis12, alt: "psoriasis" },
              { src: Psoriasis2, alt: "psoriasis" },
              { src: Psoriasis3, alt: "psoriasis" }
            
       ],
       content8:[
            {
              title1: "Homeopathic Treatment for Psoriasis at H-Cura",
              description1:
                "At H-Cura Homeopathy, we take pride in providing individualized care for every patient. Our treatment approach for psoriasis is rooted in understanding each person’s unique symptoms and triggers.",
             }],
            content9:[   {
                icon: <FaMapMarkerAlt className="feature-icon1" />,
                title: "Tailored Approach",
                description: "Our treatments focus on the individual, ensuring that every symptom is addressed comprehensively."
              },
              {
                icon: <FaUserMd className="feature-icon1" />,
                title: "Natural Remedies for Psoriasis",
                description: "Homeopathic medicines are chosen to stimulate the body’s healing mechanisms without side effects."
              },
              {
                icon: <FaClock className="feature-icon1" />,
                title: "Personalized Follow-Ups",
                description: "Regular monitoring and adjustments ensure the best results."
              }
            ],
            content10:[
              {
                title: "Why Choose H-Cura Homeopathy for Psoriasis Treatment?",
              },
            ],
            content11:[
              {
                description:
                  "Access to excellent medicines for long-lasting relief.",
              },
              {
                description:
                  "Personalized treatment plans designed for individual needs.",
              },
              {
                description:
                  "All services are delivered at your corporate location with minimal disruption.",
              },

            ],
          content12:[
            
              {
                title: "Effective Management of  Psoriasis",
              },
            
          ],
          content13:[
         
            {
              type: "list",
              content: "Types of Psoriasis We Treat",
              items: [
                "Plaque Psoriasis:The most common type, characterized by raised, inflamed patches covered with white scales.",
                "Genital Psoriasis:Requires a delicate approach to treatment.",
                "Psoriasis on hands and feet: This can lead to cracking and discomfort."
                
              ],
             
            },
            {
              type: "list1",
              content: "Key Features of Our Psoriasis Treatment",
              content1: " Our approach to psoriasis care at H-Cura includes natural remedies psoriasis that are free of harsh chemicals and tailored to individual needs. We ensure that every treatment addresses both the visible symptoms, like psoriasis rash, and the underlying causes.",
              items: [
               "Addressing psoriasis causes to minimize flare-ups.",
                "Providing relief for psoriatic arthritis symptoms, including joint pain and swelling.",
                "Managing scalp psoriasis symptoms, such as itching and redness.",
                 "Offering personalized treatment plans tailored to the severity and type of psoriasis.",
                  "Utilizing advanced therapies to reduce inflammation and promote skin healing."
              
              ],
              
            }
          
      ],

      content14:[
        {
          title: "Conclusion",
          content:
            "Psoriasis is a challenging condition, but with the right care, it can be effectively managed. At H-Cura Homeopathy Multispecialty Clinic, our dedicated team is committed to offering the best possible treatment, ensuring relief from symptoms and improved quality of life. Our personalized and holistic approach empowers patients to regain confidence and enjoy healthier, happier lives.",
        },
        {
          title: "",
          content:
            "If you or a loved one is struggling with psoriasis, don’t wait. Contact H-Cura Homeopathy today and embark on your journey toward healing and wellness. <Viral> Your health is our priority.",
        },
      ]

      
  },
//asthma
  {
    id: "asthma",
    name: "asthma",
    content: [
        { type: "heading", content: "Best Homeopathic   Asthma Treatment" },
    ],
    content1: [
        {
            type: "image",
            src: AsthmaBanner,
            alt: "Asthama-image1",
            className: "treatment-banner",
        },
        {
            type: "text",
            content: "Asthma Treatment",
            className: "treatment-text",
        },
        {
            type: "link",
            to: "/bookconsultation",
            buttonText: "Book Appointment",
            className: "book-appointment-button",
        },
    ],
    content2:[
        
            { type: "heading", content: "Best Homeopathic Asthma Treatment" },
        
    ],

    content3: [
        
        {
            type: "heading",
            content: "Asthma: Understanding, Causes, Symptoms, and Homeopathic Treatment at H-Cura Homeopathy Multispecialty Clinic",
            className: "treatmentprecautions",
        },
        {
            type: "subheading",
            content: "Understanding Asthma",
            className: "treatmentprecautions",
        },
        {
            type: "paragraph",
            content: "Asthma is a rabble-rousing condition of the airways to the lungs, making breathing and physical activities challenging. During an asthma attack, the airways’ lining becomes inflamed, and the muscles around them tighten. This leads to swelling and the production of mucus, which blocks the airways and reduces airflow. Homeopathy offers a holistic approach to managing these symptoms, ensuring natural and sustainable relief.",
            className: "treatmentprecautions",
        },
    ],

    content4:[
       
        {
          type: "list",
          content: "Causes of Asthma",
          className: "treatmentinfection1",
          items: [
            "Allergens: Common triggers include pollen, dust mites, and pet dander.",
            "Respiratory Infections:Viral or bacterial infections can exacerbate asthma.",
            "Environmental Factors:Pollution, smoke, and strong odors may irritate the airways.",
            "Genetics:A family history of asthma increases susceptibility.",
            "Certain Medications: Drugs like aspirin or beta-blockers can worsen symptoms."



            
          ],
         
        },
        {
          type: "image-overlay",
          src: Psoriasistreatment, // Replace with your actual image path
          alt: "Eczema Treatment Image",
          title: "Book an Appointment",
          description: "Effective solutions to smooth heal your breath.",
          link: "/bookconsultation",
          buttonText: "Book Appointment",
          
        }
      ],
    content5:[
       
          {
            type: "list",
            content: "Complications of Asthma",
            items: [
              "Frequent Asthma Attacks: Repeated episodes can damage the airways over time.",
              "Respiratory Failure: Severe cases may result in oxygen deprivation.",
              "Sleep Disturbance: Nighttime symptoms can affect rest and overall health."
              ],
           
          },
          {
            type: "list1",
            content: "Symptoms of Asthma",
            content1: "Symptoms vary in severity and may include:",
            items: [
              "Shortness of Breath, Difficulty breathing, especially during physical activity.",
              "Wheezing, A high-pitched sound while breathing, particularly during exhalation.",
              "Persistent Cough, Often worse at night or early morning.",
              "Chest Tightness, A feeling of pressure or discomfort in the chest.",
              "Asthma Attack Symptoms, Severe breathing difficulties, and rapid heartbeat.",
              "Allergic Asthma Symptoms, Accompanied by sneezing and nasal congestion."
                        
              
            ],
            
          }
        
    ],

    content6:[
        {
          type: "paragraph",
          content: "Diagnosis of Asthma",
          content1:
            "Asthma diagnosis involves:The diagnosis of asthma involves a comprehensive approach, beginning with a detailed medical history and symptom assessment to understand the patient's health background and current issues. Lung function tests, such as spirometry, are conducted to evaluate the airflow and capacity of the lungs. Additionally, allergy testing may be performed to identify potential triggers or allergens that could exacerbate asthma symptoms.",
          className: "treatmentDiagnosis"
        },
        
      ],

     content7:[
        
            { src: Asthma1, alt: "Asthma" },
            { src: Asthma2, alt: "Asthma"},
            { src: Asthma3, alt: "Asthma" },
            { src: Asthma4, alt: "Asthma" },
          
     ],
     content8:[
          {
            title1: "Homeopathic Treatment for Asthma at H-Cura",
            description1:
              "At H-Cura Homeopathy Multispecialty Clinic, we specialize in personalized homeopathic treatments for asthma. Our approach addresses the root causes of the condition, providing natural and effective solutions.",
           }],
          content9:[   {
              icon: <FaMapMarkerAlt className="feature-icon1" />,
              title: "Tailored Approach",
              description: "Each treatment plan is customized to the individual’s symptoms and triggers, ensuring comprehensive care."
            },
            {
              icon: <FaUserMd className="feature-icon1" />,
              title: "Natural Remedies for Asthma",
              description: "Homeopathic medicines stimulate the body’s innate healing processes without causing side effects."
            },
            {
              icon: <FaClock className="feature-icon1" />,
              title: "Personalized Follow-Ups",
              description: "Regular consultations help monitor progress and adjust the treatment as needed."
            }
          ],
          content10:[
            {
              title: "Why Choose H-Cura Homeopathy for Asthma Treatment?",
            },
          ],
          content11:[
            {
              description:
                "Holistic Management: Comprehensive approach to managing asthma symptoms and triggers.",
            },
            {
              description:
                "Safe and Effective Remedies:Side-effect-free treatments providing effective asthma relief.",
            },
            {
              description:
                "Expert Care for All Ages: Specialized expertise in treating cough variant asthma, allergic asthma, and tailored care for both children and adults.",
            },

          ],
        content12:[
          
            {
              title: "Stages and Homeopathic Treatment",
            },
          
        ],
        content13:[
       
          {
            type: "list",
            content: "Types of Psoriasis We Treat",
            items: [
              "Mild Intermittent:Managed with remedies that prevent occasional flare-ups.",
              "Mild Persistent:Treated with medicines targeting frequent symptoms.",
              "Moderate Persistent: Comprehensive care to address daily symptoms.",
              "Severe Persistent: Advanced remedies to manage chronic and severe cases."


              
              
            ],
           
          },
          {
            type: "list1",
            content: "Key Features of Our Asthma Treatment",
            content1: " Our approach to Asthma care at H-Cura includes natural remedies Asthma that are free of harsh chemicals and tailored to individual needs. We ensure that every treatment addresses both the visible symptoms, like Asthma and the underlying causes.",
            items: [
             "Addressing underlying causes to minimize asthma symptoms.",
             "Providing natural remedies for conditions like asthma cough and exercise-induced asthma.",
            "Helping manage allergic asthma symptoms effectively."
            ],
            
          }
        
    ],

    content14:[
      {
        title: "Conclusion",
        content:
          "Asthma, though challenging, can be managed effectively with the right treatment. At H-Cura Homeopathy Multispecialty Clinic, our holistic and personalized approach ensures lasting relief and improved quality of life. By targeting the root causes, we help patients achieve better control over their symptoms and lead healthier lives.",
      },
      {
        title: "",
        content:
          "If you or your loved ones are seeking a natural and effective solution for asthma, contact H-Cura Homeopathy today. Let us guide you toward a healthier, asthma-free life. Your wellness is our commitment.",
      },
    ]

    
},
//diabetes   
{
  id: "diabetes",
  name: "diabetes",
  content: [
      { type: "heading", content: "Best Homeopathic   diabetes Treatment" },
  ],
  content1: [
      {
          type: "image",
          src: diabetesBanner,
          alt: "diabetes",
          className: "treatment-banner",
      },
      {
          type: "text",
          content: "Diabetes Treatment",
          className: "treatment-text",
      },
      {
          type: "link",
          to: "/bookconsultation",
          buttonText: "Book Appointment",
          className: "book-appointment-button",
      },
  ],
  content2:[
      
          { type: "heading", content: "Best Homeopathic Diabetes Treatment" },
      
  ],

  content3: [
      
      {
          type: "heading",
          content: "Diabetes: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
          className: "treatmentprecautions",
      },
      {
          type: "subheading",
          content: "Understanding Diabetes",
          className: "treatmentprecautions",
      },
      {
          type: "paragraph",
          content: " Diabetes is a chronic metabolic condition characterized by high blood sugar levels due to insufficient insulin production or ineffective use of insulin. It can affect individuals of any age and may lead to various complications if not managed effectively.",
          className: "treatmentprecautions",
      },
  ],

  content4:[
     
      {
        type: "list",
        content: "Causes of Diabetes",
        className: "treatmentinfection1",
        items: [
          "Genetic factors: A family history of diabetes increases the risk.",
          "Lifestyle factors:Poor diet, lack of physical activity, and obesity contribute significantly to Type 2 Diabetes.",
          "Autoimmune responses:In Type 1 Diabetes, the immune system destroys insulin-producing cells.",
          "Hormonal changes:During pregnancy, hormonal imbalances can lead to Gestational Diabetes."
          ],
       
      },
      {
        type: "image-overlay",
        src: diabetesappointment, // Replace with your actual image path
        alt: "diabetes Treatment Image",
        title: "Book an Appointment  ",
        description: "Effective solutions to smooth heal your health.",
        link: "/bookconsultation",
        buttonText: "Book Appointment",
        
      }
    ],
  content5:[
     
        {
          type: "list",
          content: "Complications of Diabetes",
          items: [
            "Cardiovascular disease: Increased risk of heart attacks and strokes.",
            "Neuropathy:Damage to nerves, particularly in the extremities",
            "Nephropathy:Kidney damage, potentially leading to kidney failure.",
            "Retinopathy:Eye damage, which can result in blindness.",
            "Foot ulcers:These can lead to infections and even amputations."


           
            ],
         
        },
        {
          type: "list1",
          content: "Symptoms of Diabetes",
          content1: "Symptoms of diabetes can range from mild to severe and may include:",
          items: [
            "Increased thirst and frequent urination: Caused by high blood sugar levels.",
            "Fatigue: Due to the body's inability to use glucose for energy.",
            "Unexplained weight loss: Common in Type 1 Diabetes.",
            "Slow-healing wounds: High sugar levels impair healing.",
            "Blurred vision: Caused by fluid shifts in the lenses of the eyes.",
            "Frequent infections: Especially in the skin, gums, or urinary tract."
                      
            
          ],
          
        }
      
  ],

  content6:[
      {
        type: "paragraph",
        content: "Diagnosis of Diabetes",
        content1:
          "At H-Cura Homeopathy, we adopt a comprehensive approach to diagnosing diabetes. This includes a detailed medical history review to identify risk factors and family history, along with blood tests such as fasting blood sugar, HbA1c, and glucose tolerance tests. Additionally, we focus on identifying complications to enable early detection of diabetes-related issues and provide targeted management.",
        className: "treatmentDiagnosis"
      },
      
    ],

   content7:[
      
          { src: diabetes1, alt: "diabetes" },
          { src: diabetes2, alt: "diabetes" },
          { src: diabetes3, alt: "diabetes"},
          { src: diabetes4, alt: "diabetes" }
        
   ],
   content8:[
        {
          title1: "Homeopathic Treatment for Diabetes at H-Cura",
          description1:
            "Our homeopathic treatments focus on addressing the root causes of diabetes and promoting long-term health. By supporting the body's natural healing processes, our remedies are safe and effective.",
         }],
        content9:[   {
            icon: <FaMapMarkerAlt className="feature-icon1" />,
            title: "Blood sugar control: ",
            description: "Remedies aimed at regulating blood glucose levels naturally."
          },
          {
            icon: <FaUserMd className="feature-icon1" />,
            title:"Immune system support:",
            description: "Particularly important for Type 1 Diabetes"
          },
          {
            icon: <FaClock className="feature-icon1" />,
            title: "Reducing dependency on conventional medications:",
            description: "Gradual transition under medical supervision."
          }
        ],
        content10:[
          {
            title: "Why Choose H-Cura Homeopathy for Diabetes Treatment?",
          },
        ],
        content11:[
          {
            description:
              "H-Cura Homeopathy offers a patient-centric approach to diabetes care. Our team of experienced practitioners ensures that every patient receives personalized treatment tailored to their unique symptoms and health goals.",
          },
          {
            description:
              "At H-Cura Homeopathy, we focus on a holistic approach to improve overall health and wellness while addressing diabetes.",
          },
          {
            description:
              "Our experienced practitioners provide patient-centric care, tailoring treatments to meet your unique needs and lifestyle.",
          },

        ],
      content12:[
        
          {
            title: "Effective Management of Diabetes",
          },
        
      ],
      content13:[
     
        {
          type: "list",
          content: "Types of Diabetes We Treat Our expertise extends to managing all forms of diabetes:",
          items: [
            "Type 1 Diabetes: Focused on immune modulation and symptom control.",
            "Type 2 Diabetes: Emphasis on lifestyle modifications and metabolic balance",
            "Gestational Diabetes: Specialized care for pregnant women to ensure the health of both mother and child."

           
            
          ],
         
        },
        {
          type: "list1",
          content: "Key Features of Our Diabetes Treatment",
          content1: " Our approach to diabetes care at H-Cura includes natural remedies that are free of side effects and tailored to individual needs.",
          items: [

            "Care plans are tailored to your unique diabetes profile and health goals.",
            "Treatments include safe and gentle remedies suitable for all ages, including pregnant women.",
            "Convenient access is available through both online and offline consultations."
           
          ],
          
        }
      
  ],

  content14:[
    {
      title: "Conclusion",
      content:
        "Diabetes, though challenging, is a manageable condition with the right care and expertise. At H-Cura Homeopathy Multispecialty Clinic, we offer the best diabetes treatment that prioritizes your well-being and long-term health.",
    },
    {
      title: "",
      content:
        "Our treatments provide effective relief, from blood sugar control to managing complications, ensuring lasting results. We focus on holistic care by combining natural remedies with lifestyle management to help you achieve better overall health.<span>Your wellness is our commitment.",
    },
  ]

  
},
//migrane
{
  id: "migraine",
  name: "migraine",
  content: [
      { type: "heading", content: " Best Homeopathic Migraine Treatment at H-Cura Homeopathy Multispecialty Clinic" },
  ],
  content1: [
      {
          type: "image",
          src: migranebanner,
          alt: "migranebanner",
          className: "treatment-banner",
      },
      {
          type: "text",
          content: "migraine Treatment",
          className: "treatment-text",
      },
      {
          type: "link",
          to: "/bookconsultation",
          buttonText: "Book Appointment",
          className: "book-appointment-button",
      },
  ],
  content2:[
      
          { type: "heading", content: "Best Homeopathic Migraine Treatment" },
      
  ],

  content3: [
      
      {
          type: "heading",
          content: "Migraine: Understanding, Causes, Symptoms, and Homeopathic Treatment at HCura Homeopathy Multispecialty Clinic",
          className: "treatmentprecautions",
      },
      {
          type: "subheading",
          content: "Understanding Migraines",
          className: "treatmentprecautions",
      },
      {
          type: "paragraph",
          content: " Migraines are neurological conditions often characterized by intense, throbbing headaches accompanied by other symptoms like nausea and sensitivity to light or sound. They can last from a few hours to several days and significantly affect quality of life.",
          className: "treatmentprecautions",
      },
  ],

  content4:[
     
      {
        type: "list",
        content: "Causes of Migraines",
        className: "treatmentinfection1",
        items: [
          "Genetic predisposition: Family history increases susceptibility.",
          "Hormonal changes: Common in women during menstruation, pregnancy, or menopause.",
          "Stress and anxiety: Emotional stress can trigger migraines.",
          "Dietary factors: Certain foods or beverages like caffeine or alcohol may provoke migraines.",
          "Environmental triggers: Strong smells, bright lights, or weather changes."
          ],
       
      },
      {
        type: "image-overlay",
        src: migranappointment, // Replace with your actual image path
        alt: "migrane Treatment Image",
        title: "Book an Appointment",
        description: "Effective solutions to smooth heal your health.",
        link: "/bookconsultation",
        buttonText: "Book Appointment",
        
      }
    ],
  content5:[
     
        {
          type: "list",
          content: " Complications of Migraines When left unmanaged, migraines can lead to: ",
          items: [
            "Chronic migraine: Frequent episodes severely affecting daily life.",
            "Medication overuse headaches: Resulting from excessive use of pain relievers",
            "Mental health issues: Including anxiety and depression.",
            "Stroke: Rare, but migraines with aura slightly increase stroke risk.",
            ],
         
        },
        {
          type: "list1",
          content: "Symptoms of Migraines ",
          content1: "Migraine symptoms can vary but often include:",
          items: [
            "Intense, throbbing headache: Typically on one side of the head.",
            "Nausea and vomiting: Commonly accompany the headache",
            "Sensitivity to light and sound: Making it difficult to function normally.",
            "Aura: Visual disturbances such as flashing lights or blind spots.",
            "Fatigue and irritability: Both during and after migraine episodes.",
                      
            
          ],
          
        }
      
  ],

  content6:[
      {
        type: "paragraph",
        content: " Diagnosis of Migraines",
        content1:
          "At H-Cura Homeopathy, we employ a comprehensive approach to diagnosing migraines:",
        className: "treatmentDiagnosis"
      },
      
    ],

   content7:[
      
          { src: migrane1, alt: "migrane" },
          { src: migrane2, alt: "migrane" },
          { src: migrane3, alt: "migrane"},
          { src: migrane4, alt: "migrane" }
        
   ],
   content8:[
        {
          title1: "Homeopathic Treatment for Migraines at H-Cura",
          description1:
            "Our homeopathic treatments address the root causes of migraines while promoting long-term relief and improved well-being.",
         }],
        content9:[   {
            icon: <FaMapMarkerAlt className="feature-icon1" />,
            title: "Trigger management: ",
            description: "Remedies to reduce sensitivity to common triggers."
          },
          {
            icon: <FaUserMd className="feature-icon1" />,
            title:"Pain relief:",
            description: " Effective treatment for headache and associated symptoms."
          },
          {
            icon: <FaClock className="feature-icon1" />,
            title: "Preventive care: ",
            description: "Focused on reducing the frequency and intensity of attacks."
          },
          // {
          //   icon: <FaClock className="feature-icon1" />,
          //   title: "Holistic support: ",
          //   description: "Enhancing overall health and resilience."
          // }
        ],
        content10:[
          {
            title: " Why Choose H-Cura Homeopathy for Migraine Treatment?",
          },
        ],
        content11:[
          {
            description:
              "H-Cura Homeopathy is committed to providing patient-centered care with a focus on effective migraine management.",
          },
          {
            description:
              "Holistic approach: Treating the whole person, not just the symptoms.",
          },
          {
            description:
              "Experienced practitioners: Skilled in handling complex migraine cases.",
          },
          // {
          //   description:
          //   "Individualized care: Customized remedies for your unique needs.",
          // }

        ],
      content12:[
        
          {
            title: "Effective Management of Migraines",
          },
        
      ],
      content13:[
     
        {
          type: "list",
          content: "Our comprehensive approach combines personalized diet and lifestyle recommendations with homeopathic remedies to ensure effective migraine management.",
          items: [
            "Chronic Migraine: Targeted therapies to reduce frequency and severity.",
            "Episodic Migraine: Remedies to prevent progression to chronic conditions.",
            "Cluster Headaches: Specialized care for acute and recurring episodes."

           
            
          ],
         
        },
        {
          type: "list1",
          content: "Key Features of Our Migraine Treatment",
          content1: " Our approach to diabetes care at H-Cura includes natural remedies that are free of side effects and tailored to individual needs.At H-Cura, we provide natural, non-invasive migraine remedies that are free of side effects.",
          items: [

            "Customized care plans: Tailored to your migraine profile and health goals.",
            "Safe and gentle remedies: Suitable for all age groups, including children.",
            "Accessible care: Online and offline consultations for convenience."
           
          ],
          
        }
      
  ],

  content14:[
    {
      title: "Conclusion",
      content:
        "DMigraines, while challenging, are manageable with the right care and expertise. At H-Cura Homeopathy Multispecialty Clinic, we provide top-notch migraine treatment focused on your long-term health and well-being.",
    },
    {
      title: "",
      content:
        "Effective relief: From acute pain to preventive care, our treatments offer lasting benefits.",
    },
    {
      title: "",
      content:
        " Holistic care: Achieve better health through natural remedies and lifestyle adjustments.",
    },

  ]

  
},
//



// Add more diseases here
];